var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeciality12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.f{fill:#fff;}.a{stroke:#707070;}.b{clip-path:url(#a);}.c,.d,.e,.h{fill:none;}.c,.d,.e,.f{stroke:#208ce1;stroke-width:1.5px;}.c,.e{stroke-linecap:round;}.c{stroke-linejoin:round;}.g{stroke:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 50,
    transform: "translate(-1068 -8122)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(1068 8122)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-35.366 0.568)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-1020.644-8083.848s5.434-2.932,9.182-3.423a21.561,21.561,0,0,1,0-2.946"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-1015.69-8085.754s-1.205-1.026-4.954-1.517a21.561,21.561,0,0,0,0-2.946",
    transform: "translate(19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-1008.842-8091.154s-4.221.875-6.136-7.015c-.116-.464-.053-.9-1.109-.872a3.2,3.2,0,0,1-2.4-1.109,2.744,2.744,0,0,1,0-3.089c1.215-2.034,2.094-.991,2.773-1.268-.026-.476,0-2.007,0-2.007s3.778-.57,5.453-1.721a19.811,19.811,0,0,0,5.4-5.91c2.878,2.324,4.727,3.142,7.13,7.473v2.376a1.774,1.774,0,0,1,1.637,0c.739.476,1.644,1.137,1.353,3.3s-2.99,2.033-2.99,2.033-.749-.184-.828.344a7.482,7.482,0,0,1-6.417,7.463"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-1017.809-8104.123s-1.276-7.716,2.147-11.139,9.63-6.556,15.548-2.146,4.351,13.285,4.351,13.285"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-1010.909-8091.92c-.067-.108.212.381,0,0a23.533,23.533,0,0,1-2.116-7.1s-.893-2.5,2.41-4.329c.937-2.142,1.155-3.125,3.4-3.6s4.232,1.813,4.321,3.955c1.473.58,2.99,1.071,2.321,4.552a49.948,49.948,0,0,1-1.517,5.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-1008.529-8103.174s1.442-2.369,3.5,0"
  }), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(-1010 -8100)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 6,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    x: 0.75,
    y: 0.75,
    width: 4.5,
    height: 4.5,
    rx: 0.25
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-1007.712-8094v10.563s-.159,5.282,3.063,6.919,5.44.95,9.084,1.214",
    transform: "translate(0.94 -0.254)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeciality12);
export default __webpack_public_path__ + "static/media/speciality12.04f4d4d714fb2141a53c7d61cbb05d4f.svg";
export { ForwardRef as ReactComponent };